import {EmployeeExtendedRegistrationType} from '../../utility/extended-registration-status-type';
import {
  UserEmployeeExtendedRegistrationDataStepModel,
  UserEmployeeExtendedRegistrationFormStepModel
} from '../../user-employee-extended-registration-form/base-user-employee-extended-registration-form.model';

export enum EmployeeRegistrationFormTypes {
  REGISTRATION_FORM_TYPE_REQUESTED = 'requested',
  REGISTRATION_FORM_TYPE_ADMIN = 'admin',
}

export type EmployeeRegistrationFormType
  = typeof EmployeeRegistrationFormTypes[keyof typeof EmployeeRegistrationFormTypes];


export class EmployeeExtendedRegistrationFormModel {
  id: number;
  is_active: boolean;
  name: string;
  owner_id: number;
  profession_id: number;
  project_country_id: number;
  project_id: number;
  steps: Array<UserEmployeeExtendedRegistrationFormStepModel>;
}

export class EmployeeExtendedRegistrationDataModel extends EmployeeExtendedRegistrationFormModel {
  steps: Array<UserEmployeeExtendedRegistrationDataStepModel>;
}

export class EmployeeExtendedRegistrationModel {
  id: number;
  executor_id: number;
  extended_registration_status: EmployeeExtendedRegistrationType;
  form_id: number;
  profession_id: number;
  registration_form_type: EmployeeRegistrationFormType;
  user_id: number;
  extendedRegistrationForm: EmployeeExtendedRegistrationFormModel;
  extendedRegistrationData: EmployeeExtendedRegistrationDataModel;
}
